import {Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {IEnvironment} from './environment.interface';


@Injectable({
  providedIn: 'root'
})
export class EnvironmentService implements IEnvironment {
  get production(): boolean {
    return environment.production;
  }

  get beUrl(): string {
    return environment.be_url;
  }

  get bePersonalUrl(): string {
    return environment.be_personal_url;
  }

  get beContextApiUrl(): string {
    return environment.mydatev_context_api_url;
  }

  get stageTitle(): string {
    return environment.stageTitle;
  }

}
